import convertToImgixUrl from "@/utils/convertToImgixUrl";
import { imageCss } from "../ProseMirrorImageBlock.style";

interface InlineImageProps {
  currentImage: {
    url: string;
    alt_text?: string;
  };
  isDecorative: boolean;
}

const InlineImage = ({
  currentImage,
  isDecorative = false,
}: InlineImageProps) => {
  const altText = isDecorative ? "" : currentImage?.alt_text || "";
  const imgixUrl = convertToImgixUrl(currentImage.url);
  const ariaHidden = isDecorative ? true : undefined;

  return (
    <img src={imgixUrl} alt={altText} aria-hidden={ariaHidden} css={imageCss} />
  );
};

export default InlineImage;
